module.exports = __webpack_public_path__ + "img/5.ce5f18f4.jpg";